<template>
  <div class="m-destiny">
    <div class="m-destiny-header" :class="[ headerActive ? 'active': '']">
      <div class="m-destiny-header__logo"/>
      <div class="m-destiny-g__reg-btn m-destiny-header__btn get-gift" :class="[ userRegisterStatue ? 'registered' : '', userInvlidQualification ? 'invalid-qualification' : '' ]" @click="getGift()"/>
      <div class="m-destiny-g__play-btn m-destiny-header__btn play-free" @click="playFree()"/>
    </div>
    <div class="m-destiny-hero">
      <div class="m-destiny-hero__logo"/>
      <div class="m-destiny-hero__p">
        MapleStory's Destiny: Homecoming arrives on <span>July 20</span> with a battle against Boss Kalos and your own special home to decorate to your heart's content!
      </div>
      <div class="m-destiny-g__reg-btn m-destiny-hero__btn get-gift" :class="[ userRegisterStatue ? 'registered' : '', userInvlidQualification ? 'invalid-qualification' : '' ]" @click="getGift()"/>
      <div class="m-destiny-g__play-btn m-destiny-hero__btn play-free" @click="playFree()"/>
      <div class="m-destiny-hero__patchnote-btns">
        <a href="https://maplestory.nexon.net/news/74810/v-233-destiny-remastered-patch-notes" target="_blank"><div class="m-destiny-hero__patchnote-btn v-233"></div></a>
        <a href="https://maplestory.nexon.net/news/75294/v-234-destiny-homecoming-patch-notes" target="_blank"><div class="m-destiny-hero__patchnote-btn v-234"></div></a>
      </div>
    </div>
    <div class="m-destiny-content">
      <div class="m-destiny-content__leave m-destiny-content__leave--top-left"></div>
      <div class="m-destiny-content__leave m-destiny-content__leave--mid-top"></div>
      <div class="m-destiny-content__leave m-destiny-content__leave--mid-bottom"></div>
      <div class="m-destiny-content__leave m-destiny-content__leave--footer"></div>
      <div class="m-destiny-content__bg">
        <div class="m-destiny-content__bg-top"></div>
        <div class="m-destiny-content__bg-mid"></div>
        <div class="m-destiny-content__bg-bottom"></div>
      </div>
      <div class="m-destiny-content__inner-wrapper">

        <section class="m-destiny-g__section m-destiny-yourself-home">
          <div class="m-destiny-g__title">
             Make Yourself At Home!
             <div class="m-destiny-yourself-home__title-tag"></div>
          </div>
          <div class="m-destiny-g__p m-destiny-yourself-home__p1">
            Create your very own home in Maple World! Show off your personal sense of style with furniture, paintings, decorations and much more, and make your home an integral part of your MapleStory life with special portals and other features to get you where you need to go faster!
          </div>
          <div class="m-destiny-yourself-home__banner1"></div>
          <div class="m-destiny-yourself-home__bottom-wrapper">
            <div class="m-destiny-g__p m-destiny-yourself-home__p2">
              Head to the Town Square to purchase decorations from NPCs, find houses crafted by other players, and engage with them in mini-games and more! Creating your own place is a breeze, but with a wealth of options available, and lets you truly express yourself in Maple World!
            </div>
            <div class="m-destiny-yourself-home__banner2"></div>
            <div class="m-destiny-yourself-home__banner3"></div>
          </div>
        </section>
        <section class="m-destiny-g__section m-destiny-battle-boss">
          <div class="m-destiny-g__title">
             Battle Boss Kalos!
             <div class="m-destiny-yourself-home__title-tag"></div>
          </div>
          <div class="m-destiny-battle-boss__content-wrapper">
            <div class="m-destiny-g__p m-destiny-battle-boss__p1">
              At the top of Karotte, the Tower that Never Stops, you'll find a new foe waiting for you, the mighty Boss Kalos! This new, nigh-unstoppable mechanical beast can only be challenged by characters at least Lv. 275. The hat, top, and bottom pieces of the Lv. 250 Eternal Equipment can be claimed by those that beat the odds and defeat this mighty boss!
            </div>
            <div class="m-destiny-battle-boss__banner1"/>
            <div class="m-destiny-battle-boss__banner2"/>
          </div>
        </section>
        <!-- <section class="m-destiny-g__section m-destiny-claim">
          <div class="m-destiny-claim__img"></div>
          <div class="m-destiny-claim__content">
            <div class="m-destiny-g__title m-destiny-claim__title">
              Claim your Destiny Pre-Registration Package!
            </div>
            <div class="m-destiny-g__p">
              Get loaded up for the Destiny update with a special gift package filled with goodies! Sign up before <span>11:00 AM PDT</span> on <span>Monday, June 13</span> and receive the Lil Symphony Pets, Angelic 
              Alphabet Damage Skin, a wealth of Melody Coins, the Magician of the Sacred Forest outfit, and more when the Destiny update arrives on <span>Wednesday, June 15</span>!
            </div>
            <div class="m-destiny-g__reg-btn m-destiny-claim__btn get-gift" :class="[ userRegisterStatue ? 'registered' : '', userInvlidQualification ? 'invalid-qualification' : '' ]" @click="getGift()"/>
            <div class="m-destiny-g__play-btn m-destiny-claim__btn play-free" @click="playFree()"/>
          </div>
        </section> -->

        <section class="m-destiny-g__section m-destiny-explorer">
          <div class="m-destiny-g__title m-destiny-explorer__title">
            Explorer Revamp
            <div class="m-destiny-explorer__title-tag"></div>
          </div>
          <div class="m-destiny-g__p m-destiny-explorer__p">
            The Explorers are the original classes of MapleStory! Starting out as a simple Beginner, you can select your own path through 14 different possible jobs across all five types of MapleStory characters. They've been the backbone of MapleStory for the last 17 years, and with the Destiny update all 14 Explorer jobs will be revamped!
          </div>
          <div class="m-destiny-g__p m-destiny-explorer__p2">
            This revamp includes improved skills, better animations, new story segments to explore and more! While we've worked hard to make sure that the changes won't confuse Maplers with Explorer 
            characters, you'll have plenty to play with and “explore” with this refresh to MapleStory's oldest class of heroes!
          </div>
          <div class="m-destiny-explorer__banner"></div>
          <div class="m-destiny-explorer__class">
            <div class="m-destiny-explorer__jobs" :key="_class" v-for="_class in classInfo">
              <div class="m-destiny-explorer__class-name">{{ _class.className }}</div>
              <div class="m-destiny-explorer__job" @click="toggleJobPopup(true,job,_class)" :key="job" v-for="job in _class.jobs">
                <div class="m-destiny-explorer__job-img" :class="[ job.jobNameKey ]"></div>
                <div class="m-destiny-explorer__job-name">{{ job.jobName }}</div>
              </div>
            </div>
          </div>
        </section>
        <section class="m-destiny-bottom">
        </section>
      </div>
    </div>
    <Transition name="m-destiny-popup">
      <div class="m-destiny-job-popup" :class="[ activeJob.jobNameKey ]" v-if="activeJob">
        <div class="m-destiny-job-popup__content">
          <div class="m-destiny-job-popup__close-icon" @click="toggleJobPopup(false)"/>
          <div class="m-destiny-job-popup__title">
            {{activeJob.jobName}} 
            <div class="m-destiny-job-popup__class-type">{{activeClass.className}} Job</div>
          </div>
          <div class="m-destiny-job-popup__image-wrapper">
            <div class="m-destiny-job-popup__image" :class="[ activeJob.jobNameKey ]"></div>
          </div>

          <div class="m-destiny-job-popup__description">
            {{activeJob.jobDescription}}
          </div>
          <div class="m-destiny-job-popup__skills">
            <div class="m-destiny-job-popup__skill" :key="ability" v-for="ability in activeJob.ability">
              <div class="m-destiny-job-popup__skill-image" :class="[ ability.toLowerCase().replace(/\s/g, '-') ]"/>
              <div class="m-destiny-job-popup__skill-name">{{ability}}</div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
    <Transition name="m-destiny-popup">
      <div class="m-destiny-message-popup" v-if="messagePopup">
        <div class="m-destiny-message-popup__content">
          <div class="m-destiny-message-popup__inner-wrapper">
            <div class="m-destiny-message-popup__close-icon" @click="toggleMessagePopup(false)"/>
            <div class="m-destiny-message-popup__p">{{messagePopup}}</div>
          </div>
        </div>
      </div>
    </Transition>
    <Footer color="white" hoverColor="#254ea1" backgroundColor="#6bc8e7"/>
  </div>
</template>

<script>
import Responsive from '@/services/browser/Responsive';
import Footer from '@/components/microsites/Footer.vue';
import classInfo from './classInfo';
import axios from 'axios';
import '@/assets/scss/microsites/destiny/_destiny.scss';
import Cookie from '@/services/browser/Cookie'
import Util from '@/services/browser/Util';
import Tracking from '@/services/browser/Tracking'

const messagePopup = {
  success: "Congratulations, you've reserved your Destiny Pre-Registration Package! Join us on June 15 to claim your items and enjoy the Destiny update!",
  levelLimit: "The Destiny Pre-Registration Package is only available to accounts with a character Lv. 61 or higher.",
  alreadySignedup: "You've already registered for your Destiny Pre-Registration Package! Join us on June 15 to claim your items and enjoy the Destiny update!",
  generalError: " An error has occurred, please try again later."
}
const gtmCategory = "Destiny Remastered - Microsite";
export default {
  name: 'Microsite Destiny',
  // classInfo,
  components: {
    Footer
  },
  props: {
  },
  data(){
    return {
      classInfo,
      activeJob: false,
      activeClass: false,
      messagePopup: false,
      userRegisterStatue: false,
      userInvlidQualification: false,
      headerActive: false,
    }
  },
  computed: {
  },
  mounted(){
    Responsive.init();
    this.header();
    this.checkGiftStatue();
    // Landing Page Cookie.
    Cookie.set("mapledestiny", "true")

    // Tracking Events
    Tracking.init({
      viewEvents:{
        ".m-destiny-explorer": [ gtmCategory, "Explorer revamp"],
        ".m-destiny-bottom": [ gtmCategory, "Starlight symphony events"],
      },
      clickEvents:{
        ".m-destiny-hero__btn.get-gift": [ gtmCategory, "Get Gifts Header"],
        ".m-destiny-header__btn.get-gift": [ gtmCategory, "Get Gifts Header"],
        ".m-destiny-claim__btn.get-gift": [ gtmCategory, "Get Gifts 2"],
        ".m-destiny-hero__btn.play-free": [ gtmCategory, "Play Free Header"],
        ".m-destiny-header__btn.play-free": [ gtmCategory, "Play Free Header"],
        ".m-destiny-claim__btn.play-free": [ gtmCategory, "Play Free"],
        ".m-destiny-hero__patchnote-btn.v-233": [ gtmCategory, "Go to 233 patch notes"],
        ".m-destiny-hero__patchnote-btn.v-234": [ gtmCategory, "Go to 234 patch notes"],
        ".go-to-main-site": [ gtmCategory, "Go to Main Site"],
      }
    });
  },
  methods: {
    header(){
      const t = this;
      window.addEventListener('scroll', () => {
        (window.pageYOffset < 600) ? t.headerActive = false : t.headerActive = true;
      })
    },
    checkGiftStatue(){
      const t = this;
      setTimeout( ()=>{
        if( window.nexon.sso.isLoggedIn){
          axios.get(`/api/registerreward/get?id=1&eventNo=96`).then(( result )=>{
            const { data } = result;
            if( result && data ){
              // Success
              if( data.code == 50005) {
                t.userRegisterStatue = true;
                Cookie.set("destinyAlready", "true")
                return;
              }
            }
          })
        }
      }, 300)
    },
    playFree(){
      Util.playFree();
    },
    getGift(){
      const t = this;
      if( !t.userRegisterStatue ){
        // t.userRegisterStatue = true;
        // t.toggleMessagePopup(true,"success");
        if( !window.nexon.sso.isLoggedIn ){
          window.nexon.gnt.loginGlobal(window.location.href, 10100);
        }else{
          axios.get(`/api/registerreward/get?id=0&eventNo=96`).then(( result )=>{
            const { data } = result;
            // 0 = Success
            // 1 = The transaction is in an uncommittable state. Rolling back transaction.
            // 100 = System Error
            // 50001 = Missing Input data
            // 50002 = Invalid event_no
            // --50003 = Invalid User Id or Email
            // --50004 = The user is banned.
            // 50005 = Already participated (Nexon User ID)
            // 50006 = Already participated (Partner User ID)
            // 50010 = System Error: Maplestory User data checking error
            // 50011 = This event is for new users only
            // 50012 = This event is for existing users only
            // 50013 = This event is for active users only
            // 50014 = This event is for inactive users only
            // 50016 = Invalid qualification for event (Character Creation date)
            // 50017 = Invalid qualification for event (Level)
            // 50020 = Invalid event setting
            if( result && data ){
              // Success
              if( data.code == 0) {
                t.userRegisterStatue = true;
                t.toggleMessagePopup(true,"success");
                return;
              }
              // Already Registered
              if( data.code == 50005) {
                t.userRegisterStatue = true;
                t.toggleMessagePopup(true,"alreadySignedup");
                return;
              }
              // Invalid qualification for event (Level)
              if( data.code == 50017) {
                t.userInvlidQualification = true;
                t.toggleMessagePopup(true,"levelLimit");
                return;
              }
              // General Error
              t.toggleMessagePopup(true,"generalError");
            }
          })
        }
      }
    },
    toggleJobPopup(toggle,job,_class){
      if(toggle){
        this.activeJob = job;
        this.activeClass = _class;
        document.body.classList.add("modal-active");
        Util.sendTrackingEvent(gtmCategory, `Explorer ${job.jobName}`)
      } else{
        this.activeJob = false;
        this.activeClass = false;
        document.body.classList.remove("modal-active");
      }
    },
    toggleMessagePopup( toggle, message ){
      if( toggle ){
        this.messagePopup = messagePopup[message];
        document.body.classList.add("modal-active");
      } else{
        this.messagePopup = false;
        document.body.classList.remove("modal-active");
      }
    }
  },
};
</script>